export const NOTIFICATIONS_CACHE_KEY = '/notifications';
export const NOTIFICATIONS_PREFERENCES_CACHE_KEY = '/notifications/preferences';
